import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './task.reducer'
import * as state from './task.state'
import { defaultTaskList, TaskResponse } from './task.model'
import * as R from 'ramda'

export const taskState = createFeatureSelector<state.State>('task')

export const selectTasksWithDrafts = createSelector(taskState, reducer.selectAll)
export const selectTasksEntities = createSelector(taskState, reducer.selectEntities)

export const selectTasksWithoutDrafts = createSelector(selectTasksWithDrafts, (tasks) => {
  return tasks.filter((t) => !t.draft)
})

export const selectDraftTasks = createSelector(selectTasksWithDrafts, (tasks) => {
  return tasks.filter((t) => !!t.draft)
})

export const selectTaskById = (id: string) => createSelector(selectTasksEntities, (tasksById) => tasksById[id])

export const selectDraftTasksByInquiryId = (inquiryId: string) =>
  createSelector(selectDraftTasks, (tasks) => tasks.filter((t) => t.inquiry_id === inquiryId))

export const selectTasksByIncidentIds = (ids: string[]) =>
  createSelector(selectTasksWithDrafts, (tasks) => tasks.filter((t) => t.incident_id && ids.includes(t.incident_id)))

export const selectTaskByIncidentId = (incidentId: string) =>
  createSelector(selectTasksWithDrafts, (tasks) => tasks.find((t) => t.incident_id === incidentId))

export const selectUnarchivedTasks = createSelector(selectTasksWithoutDrafts, (items) =>
  items.filter((t) => !t.archived)
)

export const selectTaskEntities = createSelector(taskState, reducer.selectEntities)

export const isUpdatingTasks = createSelector(taskState, (state: state.State) => state.isUpdating)

export const selectTasksLoaded = createSelector(taskState, (state: state.State) => state.isLoaded)
export const selectDraftTasksLoaded = createSelector(taskState, (state: state.State) => state.isDraftLoaded)

export const selectTaskLists = createSelector(selectTasksWithoutDrafts, (tasks: TaskResponse[]) => {
  return R.pipe(
    R.map((t: TaskResponse) => t.list),
    R.prepend(defaultTaskList),
    R.filter((t) => !!t),
    R.uniq,
    R.map((t) => String(t)),
    R.sortBy((name) => String(name).toUpperCase())
  )(tasks)
})

export const selectTaskChecklists = createSelector(selectTasksWithoutDrafts, (tasks: TaskResponse[]) => {
  return R.pipe(
    R.map((t: TaskResponse) => t.checklist || []),
    R.flatten,
    R.map((t) => t.name),
    R.filter((t) => !!t),
    R.uniq,
    R.map((t) => String(t)),
    R.sortBy((name) => String(name).toUpperCase())
  )(tasks)
})
